import React, { createContext, useState } from "react";

interface Vehicle {
    id: number,
    plate: string,
    model: string,
    year: number,
    capacity: number, 
    size: number,
    restriction: string
}


interface VehicleContextProps {
    vehicle: Vehicle | null,
    setVehicle: React.Dispatch<React.SetStateAction<Vehicle | null>>
}


export const VehicleContext = createContext<VehicleContextProps>({

    vehicle: {
        id: 0,
        plate: '',
        model: '',
        year: 0,
        capacity: 0, 
        size: 0,
        restriction: ''
    },
    setVehicle: ()=>{return}
})

export const VehicleProvider: React.FC<any> = ({children})=>{
    
    const [vehicle, setVehicle] = useState<Vehicle | null>(null)

    return(
        <VehicleContext.Provider value={{vehicle, setVehicle}}>
            {children}
        </VehicleContext.Provider>
    )
}